export function inquiryToAsciiUpper(word: string): string {
    return word
        .replaceAll('Ğ', 'g')
        .replaceAll('Ü', 'u')
        .replaceAll('Ş', 's')
        .replaceAll('İ', 'I')
        .replaceAll('Ö', 'o')
        .replaceAll('Ç', 'c')
        .replaceAll('ğ', 'g')
        .replaceAll('ü', 'u')
        .replaceAll('ş', 's')
        .replaceAll('ı', 'i')
        .replaceAll('ö', 'o')
        .replaceAll('ç', 'c')
        .toUpperCase();
}

function titleCaseSegment(word: string): string {
    if (!word?.length) return '';
    return word[0].toUpperCase() + word.slice(1).toLowerCase();
}

/** Title-case city / district names for display and map matching. */
export function inquiryToDisplayName(word: string): string {
    if (!word?.length) return '';
    const bySpace = word.split(' ');
    if (bySpace.length > 1) {
        return bySpace.map((s) => inquiryToDisplayName(s)).join(' ');
    }
    const bySlash = word.split('/');
    if (bySlash.length > 1) {
        return bySlash.map((s) => titleCaseSegment(s)).join('/');
    }
    const byDash = word.split('-');
    if (byDash.length > 1) {
        return byDash.map((s) => titleCaseSegment(s)).join('-');
    }
    return titleCaseSegment(word);
}
